import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';

@Injectable()
export class NeqHttpClient {

  constructor(private httpClient: HttpClient) {
  }

  request(requestConfig: { method: string; url: string; queryParams?: any; data?: any, responseType?: any, downloadMediaType?: any, contentType?: string }): Observable<any> {

    const endpoint = requestConfig.url;
    const requestOptions: {
      headers?: HttpHeaders | {
        [header: string]: string | string[];
      },
      observe: 'body',
      params?: HttpParams | {
        [param: string]: string | string[];
      };
      reportProgress?: boolean;
      responseType: 'json';
      withCredentials?: boolean;
    } = {
      headers: {},
      params: {},
      observe: 'body',
      responseType: 'json'
    };

    if (requestConfig.queryParams) {
      requestOptions.params = requestConfig.queryParams;
      requestOptions.responseType = requestConfig.responseType;
    }

    switch (requestConfig.method) {
      case 'GET': {
        return this.requestGet(requestConfig, endpoint, requestOptions);
      }
      case 'POST': {
        return this.httpClient.post(endpoint, requestConfig.data, requestOptions);
      }
      case 'DELETE': {
        if (requestConfig.queryParams) {
          return this.httpClient.delete(endpoint, requestOptions);
        } else {
          return this.httpClient.delete(endpoint, requestConfig.data);
        }
      }
      case 'PUT': {
        return this.httpClient.put(endpoint, requestConfig.data, requestOptions);
      }
      case 'PATCH': {
        return this.httpClient.patch(endpoint, requestConfig.data, requestOptions);
      }
      case 'DOWNLOAD': {
        const downloadOptions: {
          headers?: HttpHeaders | {
            [header: string]: string | string[];
          },
          observe: 'response',
          params?: HttpParams | {
            [param: string]: string | string[];
          };
          reportProgress?: boolean;
          responseType: 'blob';
          withCredentials?: boolean;
        } = {
          responseType: requestConfig.responseType,
          observe: 'response'
        };

        if (requestConfig.queryParams) {
          if (requestConfig.downloadMediaType) {
            downloadOptions.headers['Accept'] = requestConfig.downloadMediaType;
          }
          downloadOptions.params = requestConfig.queryParams;
          return this.httpClient.get(endpoint, downloadOptions);
        } else {
          const sort = extractSort(requestConfig.data);
          if (sort) {
            requestConfig.data['sort'] = sort;
          }
          return this.httpClient.get(endpoint, {
            observe: 'response',
            params: requestConfig.data,
            responseType: requestConfig.responseType,
            headers: {'Accept': requestConfig.downloadMediaType}
          });
        }
      }
      default:
        throw new Error('Illegal argument');
    }
  }
/**
 *
 * @param requestConfig
 * @param endpoint
 * @param requestOptions
 * @returns
 */
  requestGet(requestConfig, endpoint, requestOptions){
    if (requestConfig.queryParams) {
      return this.httpClient.get(endpoint, requestOptions);
    } else {
      const sort = extractSort(requestConfig.data);
      if (sort) {
        requestConfig.data['sort'] = sort;
      }
      return this.httpClient.get(endpoint, {params: requestConfig.data, responseType: requestConfig.responseType});
    }
  }
}

function extractSort(filter: any): string[] {
  if (filter?.['sort']) {
    return filter['sort'].map(f => `${f.field};${f.asc ? 'asc' : 'desc'}`);
  } else {
    return undefined;
  }
}
